"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.parseTheme = exports.parseProp = exports.ifProp = exports.getTheme = exports.getRangeArray = exports.getProp = exports.getDefaultColor = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const getDefaultColor = (index, primaryColor) => {
  const DEFAULT_COLORS = [primaryColor, '#EEA47F', '#CCF381', '#F96167', '#C8A6F5', '#317773', '#00008B', '#E3B448', '#8A307F', '#201E20', '#2BAE66'];
  return DEFAULT_COLORS[index % 10];
};
exports.getDefaultColor = getDefaultColor;
const getProp = key => props => props[key];
exports.getProp = getProp;
const getRangeArray = function (start, end) {
  let increase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  const result = [];
  for (let i = start; i <= end; i = i + increase) {
    result.push(i);
  }
  return result;
};
exports.getRangeArray = getRangeArray;
const getTheme = key => _ref => {
  let {
    theme
  } = _ref;
  return theme[key];
};
exports.getTheme = getTheme;
const ifProp = function (key, ifTrue) {
  let ifFalse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return props => !!props[key] ? ifTrue : ifFalse;
};
exports.ifProp = ifProp;
const parseProp = (key, css) => props => !!props[key] ? "".concat(css !== null && css !== void 0 ? css : key, ": ").concat(props[key], ";") : '';
exports.parseProp = parseProp;
const parseTheme = (prop, key) => _ref2 => {
  let {
    theme
  } = _ref2;
  return "".concat(prop, ": ").concat(theme[key], ";");
};
exports.parseTheme = parseTheme;
const size = exports.size = {
  md: style => "@media (max-width: 767px) { ".concat(style, " }"),
  xs: style => "@media (max-width: 575px) { ".concat(style, " }")
};
const Button = exports.Button = _styledComponents.default.button.withConfig({
  shouldForwardProp: prop => !['activeColor', 'iconPosition', 'loading'].includes(prop)
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    all: unset;\n    box-sizing: border-box;\n    border-radius: 4px;\n\n    :focus,\n    :focus-within {\n        box-shadow: 0px 0px 1px 1px ", ";\n    };\n\n    @media print {\n        display: none !important;\n    }\n"])), getTheme('primaryColor'));